import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAoli5v11AHIrkItKIFFbFLej06H3bT7bI",
  authDomain: "kotobano-yurusikata.firebaseapp.com",
  projectId: "kotobano-yurusikata",
  storageBucket: "kotobano-yurusikata.firebasestorage.app",
  messagingSenderId: "367005092704",
  appId: "1:367005092704:web:32e6af13e888c6fdedec05",
  measurementId: "G-K8ELVN2G87"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
export default app; 
